<template>
  <mini-card :value="'$'+(card.balance || '0')" subtitle="Card balance">
    <div slot="header" class="icon-warning">
      <i class="fad fa-credit-card card-color"></i>
    </div>
    <template slot="footer">
      <div class="row small ml-0">
        <span v-if="card.status == 'active'"><i class="far fa-clock mr-2"/>Expiration date: &nbsp;<i>{{ dateToString(card.dateExpiration) }}</i></span>
        <span v-if="card.status == 'expired'"> <i class="fas fa-exclamation-triangle mr-2"/>Card expired &nbsp; </span>
        <span v-if="card.status == 'inactive'"> <i class="fas fa-info-circle mr-2"/>Card inactive &nbsp; </span>
        <span v-if="!card.status"> <i class="fas fa-exclamation-triangle mr-2"/>No card linked &nbsp; </span>
      </div>
    </template>
  </mini-card>
</template>

<script>
import utils from '../../utils'
import MiniCard from './MiniCard.vue'
export default {
    name: 'Card-Balance-MiniCard',
    components: {
      MiniCard
    },
    data () {
      return {}
    },
    computed: {
      card () {
        return this.$store.getters.paymentCard || {}
      }
    },
    methods: {
      dateToString (date) {
        return utils.dateToString(date)
      }    
    }

}
</script>

<style>

</style>